import { IconProps } from "./types";

export default function ShareIcon({ className, width, height }: IconProps) {
  return (
    <svg
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7113 31.2887C28.7113 31.2887 -3.95566 24.5309 7.3963 17.9778C16.9759 12.4482 49.9901 2.94115 54.6024 5.39759C57.0589 10.0099 47.5518 43.0241 42.0222 52.6037C35.4691 63.9557 28.7113 31.2887 28.7113 31.2887Z"
        stroke="inherit"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 31L55 5"
        stroke="inherit"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
